// =============================================================================
// ESPOLIDAR WEB ADMIN - IDLE PLAYLIST HOOKS
// =============================================================================

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { idlePlaylistApi, IdlePlaylistItem, IdlePlaylistItemCreate } from '../services/api'
import { wsService } from '../services/websocket'
import toast from 'react-hot-toast'

export function useIdlePlaylist(deviceId: string) {
  return useQuery<IdlePlaylistItem[]>({
    queryKey: ['idle-playlist', deviceId],
    queryFn: () => idlePlaylistApi.get(deviceId),
    enabled: !!deviceId,
  })
}

export function useUpdateIdlePlaylist() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ deviceId, items }: { deviceId: string; items: IdlePlaylistItemCreate[] }) =>
      idlePlaylistApi.update(deviceId, items),
    onSuccess: (_, { deviceId }) => {
      queryClient.invalidateQueries({ queryKey: ['idle-playlist', deviceId] })
      wsService.notifyConfigUpdate(deviceId)
      toast.success('Playlist aggiornata e sincronizzata')
    },
  })
}

export function useAddIdlePlaylistItem() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ deviceId, item }: { deviceId: string; item: IdlePlaylistItemCreate }) =>
      idlePlaylistApi.addItem(deviceId, item),
    onSuccess: (_, { deviceId }) => {
      queryClient.invalidateQueries({ queryKey: ['idle-playlist', deviceId] })
      wsService.notifyConfigUpdate(deviceId)
      toast.success('Elemento aggiunto e sincronizzato')
    },
  })
}

export function useDeleteIdlePlaylistItem() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ deviceId, itemId }: { deviceId: string; itemId: number }) =>
      idlePlaylistApi.deleteItem(deviceId, itemId),
    onSuccess: (_, { deviceId }) => {
      queryClient.invalidateQueries({ queryKey: ['idle-playlist', deviceId] })
      wsService.notifyConfigUpdate(deviceId)
      toast.success('Elemento rimosso e sincronizzato')
    },
  })
}

export function useClearIdlePlaylist() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (deviceId: string) => idlePlaylistApi.clear(deviceId),
    onSuccess: (_, deviceId) => {
      queryClient.invalidateQueries({ queryKey: ['idle-playlist', deviceId] })
      wsService.notifyConfigUpdate(deviceId)
      toast.success('Playlist svuotata e sincronizzata')
    },
  })
}
